export default function(el, index) {
  return { ...el, index }
}



// WEBPACK FOOTER //
// ./src/utils/assignIndex.js